<template>
  <div id="helpPage" class="fourzefour-logo">
    <img src="../assets/images/help.jpg" alt="帮助中心"/>
    <div class="container">
      <ul v-for="item in companyLists">
       <li>{{item}}</li>
    </ul>
    </div>
  </div>
</template>
<script>
  export default {
  	name: 'helpPage',
  	data () {
      return {
        companyLists:['地址：上海市长宁区定西路788号凯阳大厦4层','邮编：200050','联系人：32232323','400-666-8800']
      }
    },
  	methods: {

  	}
  }
  

</script>
<style scoped>
.fourzefour-logo{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
.fourzefour-logo .container{width: 1200px;margin: 0 auto;}
.fourzefour-logo .container ul li{line-height: 20px;font-size: 14px;}

  
</style>


// WEBPACK FOOTER //
// helpPage.vue?20900898